var map = {
	"./7-reasons.svg": 4,
	"./ChangeMaker-Hotel-Badge.svg": 5,
	"./PCH-Logo.svg": 6,
	"./accordion-seperator-desktop.svg": 7,
	"./accordion-seperator.svg": 8,
	"./arrow-curved.svg": 9,
	"./arrow-dropdown-green.svg": 10,
	"./arrow-dropdown-rotated.svg": 11,
	"./arrow-dropdown.svg": 12,
	"./arrow.svg": 13,
	"./best-price.svg": 14,
	"./breadcrumb-arrow.svg": 15,
	"./breadcrumb-home.svg": 16,
	"./bulletpoint.svg": 17,
	"./button-pause.svg": 18,
	"./button-play.svg": 19,
	"./calendar.svg": 20,
	"./check.svg": 21,
	"./close.svg": 22,
	"./ecolabel.svg": 23,
	"./email.svg": 24,
	"./facebook-no-fill.svg": 25,
	"./facebook.svg": 26,
	"./facts-separator.svg": 27,
	"./faq.svg": 28,
	"./footer-title-underline-desktop.svg": 29,
	"./footer-title-underline-mobile.svg": 30,
	"./frame-white.svg": 31,
	"./gallery.svg": 32,
	"./gemeinwohl-oekonomie.svg": 33,
	"./gift-box.svg": 34,
	"./google.svg": 35,
	"./holidaycheck.svg": 36,
	"./icon-whatsapp.svg": 37,
	"./indicator-active.svg": 38,
	"./indicator.svg": 39,
	"./instagram-no-fill.svg": 40,
	"./instagram.svg": 41,
	"./job.svg": 42,
	"./language.svg": 43,
	"./line-reasons.svg": 44,
	"./line.svg": 45,
	"./location-desktop.svg": 46,
	"./location-mobile.svg": 47,
	"./location.svg": 48,
	"./lupe.svg": 49,
	"./menu.svg": 50,
	"./menu_bar.svg": 51,
	"./newsletter.svg": 52,
	"./persons-desktop.svg": 53,
	"./persons-mobile.svg": 54,
	"./persons.svg": 55,
	"./phone.svg": 56,
	"./plus.svg": 57,
	"./quote.svg": 58,
	"./read-more.svg": 59,
	"./room-size-desktop.svg": 60,
	"./room-size-mobile.svg": 61,
	"./sample.svg": 62,
	"./separator.svg": 63,
	"./signet-en-color.svg": 64,
	"./signet-low-opacity-en.svg": 65,
	"./signet-new.svg": 66,
	"./signet-one-color-EN.svg": 67,
	"./signet-one-color-new.svg": 68,
	"./signet-one-color.svg": 69,
	"./signet.svg": 70,
	"./slide-arrow-left-green.svg": 71,
	"./slide-arrow-left-white.svg": 72,
	"./slide-arrow-right-green.svg": 73,
	"./slide-arrow-right-white.svg": 74,
	"./star-empty.svg": 75,
	"./star-full.svg": 76,
	"./star-half.svg": 77,
	"./star.svg": 78,
	"./tiktok-no-fill.svg": 79,
	"./tiktok.svg": 80,
	"./tripadvisor.svg": 81,
	"./umweltzeichen.svg": 82,
	"./underline-desktop.svg": 83,
	"./underline-mobile.svg": 84,
	"./underscore.svg": 85,
	"./view_off.svg": 86,
	"./view_on.svg": 87,
	"./whatsapp.svg": 88,
	"./youtube.svg": 89,
	"./zoom.svg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;